import { TextInput } from "@mantine/core";

/** Jednostavan izbor datuma (nativni input) — vraca ISO "YYYY-MM-DD". */
export function DateInput({ label, value, onChange }: { label: string; value: string | null; onChange: (v: string | null) => void }) {
  return <TextInput type="date" label={label} value={value ?? ""} onChange={(e) => onChange(e.currentTarget.value || null)} />;
}
